var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSailingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3571 14.6011L11.845 14.6008V1.06126C11.845 0.52854 11.2644 0.297633 10.9741 0.700227L2.3021 11.1353C2.00233 11.4975 2.23217 12.0888 2.65761 12.0888L10.8609 12.0905V14.6008H0.642162C0.231609 14.6008 0.00814056 15.1423 0.250032 15.5084C1.20602 17.0914 2.16178 18.6743 3.11777 20.2573C3.21321 20.4151 3.36604 20.4999 3.52124 20.4999L16.4778 20.5004C16.6531 20.5004 16.8069 20.3953 16.894 20.2366C17.8495 18.6542 18.8051 17.0718 19.7608 15.4894C19.9897 15.1105 19.7478 14.6017 19.3571 14.6011ZM17.6608 16.9846H2.33848L1.58233 15.7326H18.4167L17.6608 16.9846ZM3.02187 18.1163H16.9772L16.221 19.3687H3.77802L3.02187 18.1163ZM3.80683 10.9585L10.8609 2.47034V10.9585H3.80683Z",
    fill: "#2C7465"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailingIcon);
export default __webpack_public_path__ + "static/media/sailing_icon.602b7bc569e38802edee47ba6f8dfdac.svg";
export { ForwardRef as ReactComponent };